import Loading from "../../../assets/svg/loading.svg";

export const Login = ({ signInData, setSignInData, isValidEmail, handleSignIn, setStep }) => (
  <>
    <div className="flex-col align-items-center justify-content-center">
      <div className="font-32 bold text-black p-tb-32">Sign in to your account</div>
    </div>
    <div className="auth-form auth-login">
      <div className="auth-items">
        {/* email */}
        <div className="auth-row p-b-16">
          <label htmlFor="email">Email</label>
          <input
            type="text"
            placeholder="email"
            id="email"
            className={`w-100p ${!signInData.email && "error"}`}
            value={signInData.email}
            onChange={(e) => setSignInData((p) => ({ ...p, email: e.target.value }))}
          />
          {signInData.email.length === 0 && <span className="auth-input-error">This field can't be empty-item</span>}
          {signInData.email.length > 0 && (
            <span className={`auth-input-error ${isValidEmail(signInData.email) && "visibility-hidden"}`}>Format is invalid</span>
          )}
        </div>

        {/* password */}
        <div className="auth-row">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            placeholder="password"
            id="password"
            className={`w-100p ${!signInData.password && "error"}`}
            value={signInData.password}
            onChange={(e) => setSignInData((p) => ({ ...p, password: e.target.value }))}
          />
          <span className={`auth-input-error ${signInData.password.length > 0 && "visibility-hidden"}`}>This field can't be empty-item</span>
        </div>

        <div className="auth-row p-tb-24">
          <div
            className={`btn-full 
                    ${(!signInData.email || !isValidEmail(signInData.email) || !signInData.password || signInData.waiting) && "disable"}`}
            onClick={handleSignIn}>
            {signInData.waiting ? <img src={Loading} alt="" /> : <span className="p-lr-8">Continue</span>}
          </div>
        </div>

        <div className="auth-row">
          <div className="justify-content-center">
            <span onClick={() => setStep("forget")} className="fg-text-gray pointer">
              Forgot your password?
            </span>
            &#160;
            <span onClick={() => setStep("SignUp")} className="dev-mode pointer">
              Sign Up
            </span>
          </div>
        </div>
      </div>
    </div>
  </>
);
